import { DictType } from "@pma/types"
import { Popover, PopoverContent, PopoverTrigger } from "../common/popover"
import { cn } from "@pma/utils/helpers"
import { useState } from "react"
import useTranslator from "@pma/hooks/use-translator"
import { Button } from "../common/button"
import { CloudSun } from "lucide-react"
import { Rating } from "react-simple-star-rating"

interface Props {
  workDiaryDetails: DictType
}

const WorkDiaryWeather = ({ workDiaryDetails }: Props) => {
  const { translate, locale } = useTranslator()
  const isHebrew = locale == "he" ? true : false
  const [openLogs, setOpenLogs] = useState(false)

  return (
    <Popover open={openLogs} onOpenChange={setOpenLogs}>
      <PopoverTrigger asChild className='cursor-pointer'>
        <div
          className={cn("flex w-full cursor-pointer items-center gap-0", isHebrew ? "rtl" : "ltr")}
          onMouseEnter={() => setOpenLogs(true)}
          onMouseLeave={() => setOpenLogs(false)}
        >
          <Button
            variant={"ghost"}
            className='m-0 flex flex-col items-center p-0 hover:bg-transparent'
            leftSection={<CloudSun size={16} className='mx-1 text-blue-600' />}
          >
            <p className='text-xs md:text-sm'>
              {isHebrew ? workDiaryDetails?._weather?.he : workDiaryDetails?._weather?.en}{" "}
            </p>
            <Rating
              size={14}
              initialValue={workDiaryDetails?.weather_rating}
              readonly
              SVGstyle={{ display: "inline-block" }}
            />
          </Button>
        </div>
      </PopoverTrigger>
      <PopoverContent className='w-full'>
        <p className='text-xs'>
          {isHebrew ? workDiaryDetails?._weather?.he : workDiaryDetails?._weather?.en}
        </p>
        <p className='text-xs'>{`(${workDiaryDetails?.temperature}°C)`}</p>
        <p className='text-xs'>
          {translate("Rating")}: {workDiaryDetails?.weather_rating}/5
        </p>
      </PopoverContent>
    </Popover>
  )
}

export default WorkDiaryWeather
